import { collection, doc, setDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../firebase";
import { useParams } from "react-router-dom";
import {
  Button,
  Card,
  Checkbox,
  Col,
  Form,
  Input,
  Radio,
  Row,
  Space,
  message,
} from "antd";
import React, { useState } from "react";

function OnlinePayables({ data, peopleType, renderData, company }) {
  const { id } = useParams();

  const [checked, setChecked] = useState(false);
  const [value, setValue] = useState("BillPay");
  const [paymentType, setPaymentType] = useState("BillPay");
  const [form] = Form.useForm();

  const onChange = (e) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };
  const onFinish = async (values) => {
    console.log("Success:", values);
    const companiesRef = collection(db, "companies");
    const companyDocRef = doc(companiesRef, company);
    const vendorRef = collection(companyDocRef, "vendors");
    console.log("****************");
    console.log(id);
    console.log("****************");

    try {
      await updateDoc(doc(vendorRef, id), {
        onlinePaybles: {
          accountType: values.accountType,
          paymentMethods: values.paymentMethods,
          useOnlinePayables: values.useOnlinePayables,
          vendorAccountNumber: values.vendorAccountNumber,
          vendorBankRoutingNumber: values.vendorBankRoutingNumber,
        },
      });
      message.success("Online Payables updated successfully..", 3);
      renderData(true);
      setChecked(false);
    } catch (err) {
      console.error(err);
      message.error("Something is went wrong!", 3);

      // alert(err.message);
    }
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
    message.error("Something is went wrong!", 3);
  };
  const handlePaymentTypeChange = (e) => {
    setPaymentType(e.target.value);
  };

  const defaultValues = {
    vendorBankRoutingNumber: data?.vendorBankRoutingNumber,
    vendorAccountNumber: data?.vendorAccountNumber,
    holdPayments: data?.holdPayments,
    useOnlinePayables: data?.useOnlinePayables || false,
    paymentMethods: data?.paymentMethod || false,
    accountType: data?.accountType || false,

    emailCheckReceipt: data?.emailCheckReceipt,
    paymentTerms: data?.paymentTerms,
    defaultCheckMemo: data?.defaultCheckMemo,
    defaultGlAccount: data?.defaultGlAccount,
  };
  // console.log("KKKKKKKKKKKKKK");

  // console.log(data);
  // console.log("KKKKKKKKKKKKKK");

  return (

    <Row>
      <Col span={24}>
        <Card
          title="Online Payables"
        >
          {checked ? (
            <div>
              <Form
                name="basic"
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 11 }}
                colon={false}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                initialValues={defaultValues}
              >
                <Col span={24}>
                  <Form.Item
                    label="Use Online Payables"
                    name="useOnlinePayables"
                    valuePropName="checked"
                  >
                    <Checkbox></Checkbox>
                  </Form.Item>
                  <Form.Item label="Payment Method" name="paymentMethods">
                    <Space>
                      <Radio.Group
                        onChange={handlePaymentTypeChange}
                        value={paymentType}
                      >
                        <Radio value="BillPay">Bill Pay</Radio>
                        <Radio value="eCheck">eCheck</Radio>
                      </Radio.Group>
                    </Space>
                  </Form.Item>
                  <Form.Item label="Payment Type"></Form.Item>
                  <Form.Item
                    label={`${peopleType} Bank Routing Number`}
                    name="vendorBankRoutingNumber"
                  >
                    <Input disabled={paymentType === "BillPay"} />
                  </Form.Item>
                  <Form.Item
                    label={`${peopleType} Bank Account Number`}
                    name="vendorAccountNumber"
                  >
                    <Input disabled={paymentType === "BillPay"} />
                  </Form.Item>
                  <Form.Item
                    label="Savings Account?"
                    name="accountType"
                    valuePropName="checked"
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Row gutter={[8, 0]}>
                    <Col>
                      <Button type="primary" htmlType="submit">
                        Save
                      </Button>
                    </Col>
                    <Col>
                      <Button onClick={() => setChecked(false)}>Cancel</Button>
                    </Col>
                  </Row>
                </Col>
              </Form>
            </div>
          ) : (
            <Form
              colon={false}
              labelCol={{ span: 8 }}
              wrapperCol={{ span: 11 }}
              labelWrap={{ span: 8 }}
            >
              <Form.Item label="Use Online Payables">
                <p>{data?.useOnlinePayables ? "Yes" : "No"}</p>
              </Form.Item>
              <Form.Item label="Payment Type">
                <p>{data?.paymentMethods}</p>
              </Form.Item>
              <Form.Item label={`${peopleType} Bank Routing Number`}>
                <p>{data?.vendorBankRoutingNumber}</p>
              </Form.Item>
              <Form.Item label={`${peopleType} Bank Account Number`}>
                <p>{data?.vendorAccountNumber}</p>
              </Form.Item>
              <Form.Item label="Account Type">
                <p>{data?.accountType ? "Saving Account" : "--"}</p>
              </Form.Item>
              {peopleType === "Vendor" ? (
                <>
                  <Form.Item label="Last Payment Preference Updated Date">
                    <p>--</p>
                  </Form.Item>
                  <Form.Item label="Last Payment Preference Updated By">
                    <p>--</p>
                  </Form.Item>
                </>
              ) : null}
            </Form>
          )}
        </Card>
      </Col>
    </Row>
  );
}

export default OnlinePayables;
